// VOY-485 (rebuild) — Places visited (Public profile tab, last 12 months).
//
// Tile per distinct destination from confirmed orders in the trailing year.
// Sorted by visit count desc. Country code is best-effort and may be null.

import type { PlaceVisited } from '@/lib/profile'

export interface PlacesVisitedSectionProps {
  places: PlaceVisited[]
}

export function PlacesVisitedSection({ places }: PlacesVisitedSectionProps) {
  return (
    <section className="card" aria-labelledby="places-h">
      <div className="card-h">
        <h3 id="places-h">Places visited</h3>
        <span className="meta">LAST 12 MONTHS</span>
      </div>
      {places.length === 0 ? (
        <p style={{ color: 'var(--v6-fg-muted)', fontSize: 13.5, margin: 0 }}>
          No trips in the last 12 months yet — your next destination shows up here once it&apos;s confirmed.
        </p>
      ) : (
        <div className="grid-4">
          {places.map((p) => (
            <div key={`${p.city}-${p.country_code ?? '??'}`} className="place-tile">
              <div className="place-tile-row">
                <div>
                  <div className="place-tile-name">{p.city}</div>
                  {p.country_code && <div className="lbl place-tile-cc">{p.country_code}</div>}
                </div>
                <div className="num place-tile-count">×{p.visit_count}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}
